import { render, staticRenderFns } from "./WorkOrderHome.vue?vue&type=template&id=04d47fce&scoped=true&"
import script from "./WorkOrderHome.vue?vue&type=script&lang=js&"
export * from "./WorkOrderHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d47fce",
  null
  
)

export default component.exports